import React from 'react';

/**
 * PersonaErrorBoundary — catches any render/runtime error inside the Persona
 * studio and shows the error text ON SCREEN instead of letting it blank the
 * whole app. Scoped to Persona only, so a bug here can never white-screen the
 * rest of the portal. Also logs the full error + component stack to the console.
 */
export default class PersonaErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Surface the full detail in the console for debugging.
    // eslint-disable-next-line no-console
    console.error('[Persona] render error:', error, info);
    this.setState({ info });
  }

  render() {
    if (this.state.error) {
      const msg = (this.state.error && (this.state.error.message || String(this.state.error))) || 'Unknown error';
      const stack = (this.state.info && this.state.info.componentStack) || (this.state.error && this.state.error.stack) || '';
      return (
        <div style={{ margin: '10px', padding: '18px', border: '1px solid #f5c2c7', borderRadius: '8px', backgroundColor: '#fff5f5' }}>
          <h3 style={{ margin: '0 0 8px 0', color: '#b00020' }}>Persona hit an error (contained — the rest of the app is fine)</h3>
          <div style={{ fontSize: '13px', color: '#7a1020', fontWeight: 'bold', marginBottom: '8px' }}>{msg}</div>
          <pre style={{ fontSize: '11px', color: '#555', whiteSpace: 'pre-wrap', maxHeight: '240px', overflow: 'auto', background: '#faf0f0', padding: '10px', borderRadius: '6px' }}>{stack}</pre>
          <button onClick={() => this.setState({ error: null, info: null })}
            style={{ marginTop: '10px', padding: '7px 14px', backgroundColor: '#0073bb', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
            Dismiss
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
